import {Box} from '@indoqa/style-system'
import {IStyle} from 'fela'
import {useFela} from 'react-fela'
import {Theme} from '../../../app/theme'
import {ArLink} from '../links/ArLink'

interface ArAnsprechpartnerCardProps {
  readonly name: string
  readonly role: string
  readonly email: string
  readonly phone: string
  readonly photo: string
}

const PHOTO_SIZE = 144

export function ArAnsprechpartnerCard({name, role, email, phone, photo}: ArAnsprechpartnerCardProps) {
  const {css, theme} = useFela<Theme>()

  // On mobile the photo sits centered above the text, because photo and email address side by side
  // are wider than the screen.
  const cardStyle: IStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    tablet: {
      flexDirection: 'row',
      textAlign: 'left',
    },
  }
  // The global `img` rule in DigitalCSSRules centers every image at 80% width, which has to be
  // undone here.
  const photoStyle: IStyle = {
    width: PHOTO_SIZE,
    height: PHOTO_SIZE,
    flexShrink: 0,
    borderRadius: '50%',
    margin: 0,
    marginBottom: theme.spacing.space4,
    tablet: {
      marginBottom: 0,
      marginRight: theme.spacing.space6,
    },
  }

  return (
    <div className={css(cardStyle)}>
      <img src={`${process.env.PUBLIC_URL}/${photo}`} alt={name} className={css(photoStyle)} />
      <Box>
        <Box<Theme> fontStyle="brandBold">
          {name}
          <br />
          {role}
        </Box>
        <Box pt={2}>
          <ArLink name={email} link={`mailto:${email}`} />
        </Box>
        <Box>M: {phone}</Box>
      </Box>
    </div>
  )
}
